function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 100vh;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n      transform: translateY(100px);\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n\n  .toggleAnimation {\n    animation: fadeOut 0s;\n    animation: fadeIn 0.5s;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  overflow-y: auto;\n\n  p {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .question {\n    margin: 10px 0;\n  }\n\n  .question-final {\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: 25px;\n\n    > p {\n      font-weight: ",
        ";\n      font-size: ",
        ";\n    }\n  }\n\n  .no-quote {\n    padding-bottom: 0;\n    border-bottom: none;\n    margin-bottom: 0;\n\n    p {\n      padding-bottom: 10px;\n    }\n\n    p:last-child {\n      padding-bottom: 0;\n    }\n  }\n\n  .answer-button {\n    width: ",
        ";\n    flex: 1 0 auto;\n    line-height: 30px;\n    margin: 10px 0 5px 0;\n    text-align: left;\n    transition: all 400ms;\n    color: ",
        ";\n    border: ",
        ";\n    background: ",
        ";\n    display: flex;\n  }\n\n  .answer-button:focus {\n    outline: none;\n  }\n\n  .answer-button:hover {\n    transition: all 400ms;\n    box-shadow: ",
        ";\n  }\n\n  .answer-button.selected {\n    background-color: ",
        ";\n    border: ",
        ";\n    color: ",
        ";\n  }\n\n  .selected-answer-help {\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  .start-over svg {\n    padding-bottom: 3px;\n    margin-right: 3px;\n  }\n\n  .start-over,\n  .dropdown {\n    display: inline-block;\n  }\n\n  .send-to-vms {\n    padding: 12px 20px 13px;\n    margin-left: 10px;\n  }\n\n  .dropdown,\n  .dropdown-trigger,\n  .dropdown-list {\n    max-width: 220px;\n  }\n\n  .dropdown-list {\n    z-index: 100;\n  }\n\n  .dropdown-list button {\n    width: 100%;\n    border-radius: 0;\n  }\n\n  .dropdown-trigger button {\n    width: 100%;\n  }\n\n  button {\n    margin-right: 10px;\n    width: auto;\n    padding: ",
        ";\n    border-radius: ",
        ";\n\n    svg {\n      vertical-align: middle;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n\n  svg {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  .question-summary {\n    margin-top: 25px;\n    color: ",
        ";\n    padding-bottom: 5px;\n  }\n\n  .answer-summary {\n    color: ",
        ";\n  }\n\n  p {\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: normal;\n  display: ",
        ";\n  font-size: ",
        ";\n  line-height: 20px;\n  margin: 5px 0;\n  color: ",
        ";\n  white-space: normal;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import propTypes from "prop-types";
export var HeaderContainer = styled.p(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.questions.fontSize;
});
export var DecisionTreeContainer = styled.div(_templateObject1());
export var DecisionTreeBody = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.components.card.borderColor;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.questions.finalQuestionFontWeight;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.questions.finalQuestionFontSize;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.width;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.color;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.border;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.hoverBoxShadow;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.selectedAnswer;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.selectedAnswerBorder;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.selectedAnswerColor;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.selectedAnswerColor;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.dynamicLayout && "\n    display: inline-flex;\n    flex-direction: column;\n\n    .answer-button {\n      flex: 1;\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      flex-direction: row;\n      flex-wrap: wrap;\n\n      .answer-button {\n        flex: 1 0 auto;\n        width: 100%;\n      }\n    }\n  ";
});
export var DecisionTreeFooter = styled.div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.footer.buttonPadding;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.footer.buttonBorderRadius;
});
export var AnswerText = styled.span(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.fontWeight;
});
export var AnswerIcon = styled.span(_templateObject5());
export var AnswersSummary = styled.div(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.questionSummaryColor;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.answerSummaryColor;
});
export var HelperText = styled.span(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.helpText.display;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.helpText.fontSize;
}, function(param) {
    var theme = param.theme;
    return theme.components.decisionTree.answers.helpText.color;
});
export var RenderHelpText = function(param) {
    var answer = param.answer, selected = param.selected;
    return /*#__PURE__*/ React.createElement(HelperText, {
        className: selected ? "selected-answer-help" : "",
        dangerouslySetInnerHTML: {
            __html: answer.help
        }
    });
};
RenderHelpText.propTypes = {
    answer: propTypes.any,
    selected: propTypes.any
};
